import { useSelector } from "react-redux";

import { selectUIVersion } from "store/app";
import ProductsSelectorV1 from "./ProductsSelectorV1";
import ProductsSelectorV2 from "./ProductsSelectorV2";

export default function ProductsSelector({
  title,
  appDivider,
  uiText,
  appHeaderLogo,
  appLogo,
  products = [],
  selectedProduct,
  selectProduct,

  position,
  top,
  left,
  right,
  containerTop,
  labelTop,
  labelLeft,
  customCardLayout,
}) {
  const UIVersion = useSelector(selectUIVersion);

  switch (UIVersion) {
    case 2:
      return (
        <ProductsSelectorV2
          title={title}
          appDivider={appDivider}
          uiText={uiText}
          appHeaderLogo={appHeaderLogo}
          appLogo={appLogo}
          products={products}
          selectedProduct={selectedProduct}
          selectProduct={selectProduct}
        />
      );

    default:
      return (
        <ProductsSelectorV1
          title={title}
          products={products}
          selectedProduct={selectedProduct}
          selectProduct={selectProduct}
          //
          position={position}
          top={top}
          left={left}
          right={right}
          containerTop={containerTop}
          labelTop={labelTop}
          labelLeft={labelLeft}
          customCardLayout={customCardLayout}
        />
      );
  }
}
